import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Grid, Tooltip, styled } from "@mui/material";
import { ILogicModifierTypes } from "src/components/LogicModifiers/LMGroupChip";

interface ILogicModifierCell {
  logicModifiers: ILogicModifierTypes[];
}

const OCLogicModifierGroupsCell = styled(Grid)(({ theme }) => ({
  flexWrap: "wrap",
  justifyContent: "flex-start",
}));

/**
 * Takes in an array of LMs and displays them as a group.
 * @param props - Array of logic modifiers
 */
export const LogicModifierGroupsCell = (props: ILogicModifierCell): JSX.Element => {
  const { logicModifiers } = props;

  return (
    <OCLogicModifierGroupsCell container direction="row">
      {logicModifiers?.length > 0 &&
        logicModifiers.map((lm) => (
          <Tooltip enterDelay={800} placement="top" title={lm.logicModifier.description} key={lm._id}>
            <FiberManualRecordIcon style={{ color: `#${lm.logicModifier.color}` }} stroke={"black"} strokeWidth={1}>
              {lm.logicModifier.title}
            </FiberManualRecordIcon>
          </Tooltip>
        ))}
    </OCLogicModifierGroupsCell>
  );
};
